import styles from '../Slots.module.scss';
import { ESlotType } from '../../../../1_shared/config/enums/ESlotType';
import QuestionIcon from '../../../../1_shared/assets/pictures/QuestionIcon.svg';
import dayjs from 'dayjs';
import { Tooltip } from 'antd';
import { Typography } from '../../../../1_shared/ui';

interface ISlotInfoContentProps {
  kind: ESlotType;
  start: string;
  price?: number;
}

const SUPERVISION_TULTIP_COLOR = '#E6F6FF';
/**
 * TODO: Вынести компонент тултипа в шаред слой для нормально переиспользуемости.
 * NOTE: Дочерний компонент компонента слотов, который выводит внутреннюю информацию кнопки слота
 * @expample
 * (10:00) - элемент обычного слота
 * @expample
 * ((?) 13:30) - элемент слота супервизии, при наведении на который
 * будет выводиться тултип с информациейо цене за сеанс супервизии
 * @param {ESlotType} kind - тип слота
 * @param {string} start - время свободного сеанса (слота)
 * @param {number | undefined} price - цена слота супервизии
 */
const SlotInfoContent = ({ kind, start, price }: ISlotInfoContentProps) => (
  <div className={styles.slotInnerContent}>
    {kind === ESlotType.Supervision && (
      <Tooltip
        color={SUPERVISION_TULTIP_COLOR}
        placement="top"
        className={styles.tooltip}
        title={
          <Typography component={'span'}>
            Супервизия <br /> Cтоимость: {price} ₽
          </Typography>
        }
      >
        <img
          src={QuestionIcon}
          alt="question-icon"
          className={styles.supervisionIcon}
        />
      </Tooltip>
    )}
    {dayjs(start).format('HH:mm')}
  </div>
);

export default SlotInfoContent;
